export interface IStatusCodeMessage {
  statusCode: number;
  message: string;
}

export enum IOperatingSystemEnums {
  WINDOWS = "WINDOWS",
  MAC_OS = "MAC OS",
  LINUX = "LINUX",
  ANDROID = "ANDROID",
  IOS = "IOS",
  UNKNOWN_OS = "UNKNOWN OS",
}

export enum IAddClinicTeamMemberEnums {
  ASSOCIATED_CLINICAL_TEAM = "ASSOCIATED_CLINICAL_TEAM",
  SEARCHED_MEMEBER = "SEARCHED_MEMEBER",
  CHAT = "CHAT",
  HOSPITAL_TEAMS = "HOSPITAL_TEAMS",
}

export interface IKeyValueChip {
  label: string | React.ReactNode;
  value: string;
  isBooked?: boolean;
  isSelection?: boolean;
}
export enum NavDropdownType {
  ADD_PATIENT = "ADD_PATIENT",
  PROFILE = "PROFILE",
  PHARMACY = "PHARMACY",
  DIAGNOSTIC_CENTER = "DIAGNOSTIC_CENTER",
}

export enum IResetAppState {
  RESET_ALL = "RESET_ALL",
}

export enum IConfigKey {
  OUR_APP_FEATURE = "OUR_APP_FEATURE",
  PARTNER_WITH_US = "PARTNER_WITH_US",
  COUNTRY_CODE = "COUNTRY_CODE",
}

export interface ICountryCodeList {
  [key: string]: {
    code: string;
    len: string;
  };
}

export enum ISelectCountryType {
  MAKE_APPOINTMENT = "MAKE_APPOINTMENT",
  MAKE_APPOINTMENT_MOBILE_OR_TABLET = "MAKE_APPOINTMENT_MOBILE_OR_TABLET",
}

export enum IBannerRedirection {
  FIND_DOCTOR = "FIND_DOCTOR",
  MEDICINES = "MEDICINES",
  TEST = "TEST",
  HEALTH_HUB = "HEALTH_HUB",
  HELP_ME_CHOOSE_FORM = "HELP_ME_CHOOSE_FORM",
  SUPPORT_CHAT = "SUPPORT_CHAT",
  ALL_ORDERS = "ALL_ORDERS",
  HEALTH_ASSESSMENT_BRAIN = "HEALTH_ASSESSMENT_BRAIN",
  HEALTH_ASSESSMENT_SPINE = "HEALTH_ASSESSMENT_SPINE",
  PROFILE_MEDICAL_RECORDS = "PROFILE_MEDICAL_RECORDS",
  CHAT_LIST = "CHAT_LIST",
}

export interface IRedirectAfterLogin {
  path: string;
  navItem: number;
  isRedirect: boolean;
  [key: string]: string | number | boolean;
}

export enum IRedirectAfterLoginType {
  DOCTOR_PROFILE = "DOCTOR_PROFILE",
  FIND_DOCTOR = "FIND_DOCTOR",
  MEDICINES = "MEDICINES",
  TEST_REPORTS = "TEST_REPORTS",
  HEALTH_HUB = "HEALTH_HUB",
}

export enum IRedirectAfterLoginAction {
  OPEN_ADDRESS_FORM = "OPEN_ADDRESS_FORM",
  SELECT_AND_PROCEED = "SELECT_AND_PROCEED",
  APPOINTMENT_CREATION = "APPOINTMENT_CREATION",
  OPEN_APPOINTMENT_CHECKOUT = "OPEN_APPOINTMENT_CHECKOUT",
}
export enum ISessionKeys {
  ROLE_TYPE = "roleType",
  USER_ID = "user_id",
  LANG = "lang",
  BASIC_AUTH = "BasicAuth",
  DEVICE_ID = "deviceId",
  DEVICE_TOKEN = "deviceToken",
  TOKEN = "token",
  NAME = "name",
  HAS_SEEN_PWA_POPUP = "hasSeenPwaPopup",
  LOCATION = "location",
  PHONE_NUMBER = "phone_number",
  PROFILE_PHOTO = "profile_photo",
  COUNTRY_CODE = "country_code",
  CLINIC_ID = "clinic_id",
  DOCTOR_ID = "doctorId",
  DOCTOR_NAME = "doctorName",
  CONSULTATION_FEE = "consultationFee",
  DOCTOR_NAME_UNDERSCORE = "doctor_name",
}

export enum IRemoveReviewActionType {
  REMOVE_REVIEW = "REMOVE_REVIEW",
  REMOVE_REPLY = "REMOVE_REPLY",
}

export enum IDashboardTabEnum {
  DASHBOARD = "DASHBOARD",
  SCHEDULE_REPORTS = "SCHEDULE_REPORTS",
  APPOINTMENT_REPORTS = "APPOINTMENT_REPORTS",
  MEDICAL_PARTNER = "MEDICAL_PARTNER",
  STAFF_REPORTS = "STAFF_REPORTS",
}

export interface ILabelValue {
  label: any;
  value: string;
}

export enum IUniversalSearchFilterType {
  SCHEDULE = "SCHEDULE",
  IP_DASHBOARD = "IP_DASHBOARD",
  RECEPTION = "RECEPTION",
  CLINIC_APPOINTMENTS = "CLINIC_APPOINTMENTS",
}

export interface IUniversalSearchFilter {
  schedule: Record<string, string>;
  ipDashboard: Record<string, string>;
  reception: Record<string, string>;
  clinicAppointments: Record<string, string>;
  currentActivBottomNavItem: number | null;
}
